import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';
import LeaseExpirationReminderForm from './lease_expiration_reminder_form';
import listingPropTypes from 'components/listing/prop_types';

export const leaseRateUnitsLabels = {
  dollars_per_sf_per_year: '$/SF/year',
  dollars_per_acre_per_year: '$/Acre/year',
  dollars_per_year: 'Annual Rent',
  dollars_per_acre_per_month: '$/Acre/month',
  dollars_per_month: 'Monthly'
};

export const leaseTermUnitsLabels = { months: 'Months', years: 'Years' };

export const spaceSizeUnitsLabels = { sf: 'SF', acres: 'Acres' };

export default class ListingLeaseInfo extends React.Component {
  static propTypes = {
    fieldsRequired: PropTypes.bool,
    listing: listingPropTypes.isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.props.onChange({ [name]: value });
  }

  render() {
    const { leaseDate, leaseTerm, leaseTermUnits, renewalReminder } = this.props.listing;
    const labels = [];
    if (!leaseDate) labels.push("Lease Begins");
    if (!leaseTerm) labels.push("Lease Term");
    if (!leaseTermUnits) labels.push("Lease Term Units");

    return (
      <React.Fragment>
        <h4 className="pt-4">Description of Lease</h4>
        {this.renderLeaseInfo()}

        <LeaseExpirationReminderForm
          disabled={!(leaseDate && leaseTerm && leaseTermUnits)}
          disabledTooltip={`${labels.join(', ')} required to set reminder`}
          renewalReminder={renewalReminder}
          onChange={this.props.onChange}
        />
      </React.Fragment>
    );
  }

  renderLeaseInfo() {
    const { fieldsRequired, listing } = this.props;
    const { leaseDate, leaseRate, leaseTerm, spaceSize } = listing;
    const requiredClass = fieldsRequired ? 'required' : '';

    return <React.Fragment>
      <div className={`form-group ${requiredClass}`}>
        <label className="control-label">Space Size</label>
        <div className="form-input-container">
          <ManagedInput
            className="form-control"
            name="spaceSize"
            required={fieldsRequired}
            type="number"
            value={spaceSize}
            onChange={this.props.onChange}
          />
        </div>
      </div>

      <div className={`form-group mb-4 ${requiredClass}`}>
        <label className="control-label">Space Size Units</label>
        <div className="form-inline radio-fields">
          {this.renderInlineRadioButtons(spaceSizeUnitsLabels, 'spaceSizeUnits', fieldsRequired)}
        </div>
      </div>

      <div className="form-group">
        <label className="control-label">Lease Rate</label>
        <div className="form-input-container">
          <ManagedInput
            allowEmpty
            className="form-control"
            name="leaseRate"
            type="currency"
            value={leaseRate}
            onChange={this.props.onChange}
          />
        </div>
      </div>

      <div className="form-group mb-4">
        <label className="control-label">Lease Rate Units</label>
        <div className="form-inline radio-fields">
          {this.renderInlineRadioButtons(leaseRateUnitsLabels, 'leaseRateUnits')}
        </div>
      </div>

      <h4 className="pt-4">Terms of Lease</h4>

      <div className={`form-group ${requiredClass}`}>
        <label className="control-label">Lease Term</label>
        <div className="form-input-container">
          <ManagedInput
            className="form-control"
            name="leaseTerm"
            required={fieldsRequired}
            type="number"
            value={leaseTerm}
            onChange={this.props.onChange}
          />
        </div>
      </div>

      <div className={`form-group ${requiredClass}`}>
        <label className="control-label">Lease Term Units</label>
        <div className="form-inline radio-fields">
          {this.renderInlineRadioButtons(leaseTermUnitsLabels, 'leaseTermUnits', fieldsRequired)}
        </div>
      </div>

      <div className={`form-group ${requiredClass}`}>
        <label className="control-label">Lease Begins</label>
        <div className="form-input-container datepicker-full-width">
          <ManagedInput
            className="pr-2 form-control"
            name="leaseDate"
            required={fieldsRequired}
            type="date"
            value={leaseDate}
            onChange={this.props.onChange}
          />
        </div>
      </div>
    </React.Fragment>;
  }

  renderInlineRadioButtons(labelsByValue, name, required) {
    return <React.Fragment>
      {Object.keys(labelsByValue).map((value, i) => (
        <Radio
          checked={this.props.listing[name] === value}
          className="radio-inline-label radio"
          inline
          key={i}
          name={name}
          required={required}
          value={value}
          onChange={this.handleChange}
        >
          {labelsByValue[value]}
        </Radio>
      ))}
    </React.Fragment>;
  }
}
